import { Stack as MuiStack } from "@mui/material";
import { Info as MuiInfoIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const StatusCell = ({ row, getStatusIcon, handleOpenRecentActivityDialog }) => {
  const { t } = useTranslation();

  return (
    <MuiStack direction="row" alignItems="center" gap={0.5}>
      {getStatusIcon(t(`importStatus.${row.status}`))}
      {t(`importStatus.${row.status}`)}
      <MuiInfoIcon
        onClick={() => handleOpenRecentActivityDialog(row)}
        sx={{ cursor: "pointer", fontSize: "20px" }}
      />
    </MuiStack>
  );
};

export default StatusCell;
